<template>
	<transition 
			appear
			:appear-active-class="$_sales_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					class="customVContainer"
					:style="$_sales_stylePageContainerStyle()"
					fluid>
				<!-- products -->
				<template v-if="$_sales_routeName == 'salesMerchant' && $_sales_paramsMerchantId">
					<template v-if="!onLoading_">
						<sales-product-card-layout
							:merchants="$_sales_merchants()"

							:contents="$_sales_contents()"
							:inits="$_sales_inits()" />
					</template>
				</template>
				<!-- serial number input -->
				<template v-else-if="$_sales_routeName == 'salesInput' && $_sales_paramsMerchantId">
					<sales-input-layout
						:contents="$_sales_contents()"
						:inits="$_sales_inits()" />
				</template>
				<!-- page title -->
				<template v-else>
					<page-title-layout
							:inits="$_sales_inits()" />
				</template>
			</v-container>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Sales',
		data() {
			return {
				pageName_: 'sales',
				pageType_: 'sales',

				initialized_: false,

				onLoading_: false,

				salesMerchant_: {},
				salesProduct_: {}
			}
		},
		computed: {
			// route
			$_sales_routeName() {
				const self_ = this;
				const route_ = self_.$route
				return route_.name
			},
			// params
			$_sales_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_sales_paramsMerchantId() {
				const self_ = this;
				const params_ = self_.$_sales_params;
				if(self_.isFalse(params_)) { return null }
				return params_.merchantId
			},
			$_sales_paramsProductId() {
				const self_ = this;
				const params_ = self_.$_sales_params;
				if(self_.isFalse(params_)) { return null }
				return params_.productId
			},
			// current user
			$_sales_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_sales_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_sales_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			$_sales_stateUserSales() {
				const self_ = this;
				return self_.getUserState('sales')
			},
			// sales
			$_sales_merchants() {
				const self_ = this;
				return () => {
					return self_.salesMerchant_
				}
			},
			$_sales_products() {
				const self_ = this;
				return () => {
					return self_.salesProduct_
				}				
			},
			// contents / inits
			$_sales_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_sales_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_sales_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_sales_inits(), 'contact')
			},
			// style
			$_sales_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_sales_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_sales_inits(), 'page')
				}
			},
			$_sales_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_sales_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_sales_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_sales_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_sales_inits(), 'pageContainer')
			},
			$_sales_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_sales_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		watch: {
			$route() { 
				const self_ = this;
				if(self_.$_sales_routeName == 'sales') { self_.$_sales_updateRoute() }
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_sales_setPageState()

			if(self_.$_sales_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_sales_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)

			self_.$_sales_updateRoute()
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_sales_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_sales_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_sales_initialize()', error)
				})
			},
			$_sales_getSalesByMerchantIdAndProductId() {
				const self_ = this;

				if(!self_.isEmpty(self_.salesProduct_)) { return true }

				Promise.resolve().then(() => {
					return self_.getSalesByMerchantIdAndProductId(self_.$_sales_paramsMerchantId, self_.$_sales_paramsProductId)
				}).then(result => {
					self_.salesProduct_ = result;
					return true
				}).catch(error => {
/* error */			self_.logError('Error', '$_sales_getSalesByMerchantIdAndProductId()', error)

					return false
				})
			},
			$_sales_selectSerialNumber(serialNumberVals, serialNumberIndex) {
				const self_ = this;

				self_.serialNumber_ = serialNumberIndex;
				self_.serialNumberTitle_ = self_.$_sales_langContentSerialNumberTitle(serialNumberVals)
			},
			$_sales_updateRoute() {
				const self_ = this;
				const router_ = self_.$router;

				// initialize sales
				self_.$_sales_initializeSalesMerchant()

				self_.salesMerchant_ = {}
				self_.salesProduct_ = {}

				if(self_.$_sales_paramsMerchantId) {
					router_.replace({
						name: 'salesMerchant',
						params: {
							merchantId: self_.$_sales_paramsMerchantId
						}
					})
				}
			},
			$_sales_initializeSalesMerchant() {
				const self_ = this;

				if(!self_.isEmpty(self_.salesMerchant_)) { return true }

				self_.onLoading_ = true;

				Promise.resolve().then(() => {
					return self_.getSalesByMerchantId(self_.$_sales_paramsMerchantId)
				}).then(result => {
					self_.salesMerchant_ = result;

					self_.onLoading_ = false;

					return true
				}).catch(error => {
/* error */			self_.logError('Error', '$_sales_initializeSalesMerchant()', error)

					return false
				})
			}
		}
	}
</script>

<style scoped>
</style>